import React from 'react';
import CasesWorkspace from './CasesWorkspace';

const TestCasesPage = () => <CasesWorkspace />;

export default TestCasesPage;
